import { render, staticRenderFns } from "./VendorInfo.vue?vue&type=template&id=d6394004&scoped=true&"
import script from "./VendorInfo.vue?vue&type=script&lang=ts&"
export * from "./VendorInfo.vue?vue&type=script&lang=ts&"
import style0 from "./VendorInfo.vue?vue&type=style&index=0&id=d6394004&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6394004",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VImg,VProgressCircular})
